var render, staticRenderFns
import script from "./PageUp.vue?vue&type=script&lang=js"
export * from "./PageUp.vue?vue&type=script&lang=js"
import style0 from "./PageUp.vue?vue&type=style&index=0&id=c53775d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53775d2",
  null
  
)

export default component.exports